import HoverTooltip from "./HoverTooltip.jsx";

// The trace panel's readings, as a joined group of the detail header's own
// buttons (the request stepper and the expand control beside it are the same
// 24px bordered cells), so the switcher reads as part of that line rather than
// as loose words next to boxes (found live). The active reading takes the
// control group's green ground, at one weight for every word so nothing moves
// when the reading arrives asynchronously, and with no colour transition: the
// marker and the reading change in one commit, and a 150ms fade on the text
// read as the toggle catching up after the view (found live). Workspace, beside
// it, opens the session in a workspace of its own over the page.
//
// The loaded panel and its placeholder both draw this one group, so the line
// keeps its shape as the trace lands.
export default function ReadingSwitcherGroup({ options, active, onSelect, onWorkspace = null }) {
  return (
    <div data-reading-switcher-group="" className="inline-flex h-[24px] shrink-0 items-stretch">
      {options.map(([value, label], i) => (
        <button
          key={value}
          type="button"
          onClick={() => onSelect(value)}
          aria-pressed={active === value}
          className={[
            "grid h-[24px] place-items-center border border-[color:var(--line)] bg-[color:var(--control-bg)] px-[8px]",
            "text-[11px] leading-[1] tracking-[0.06em] uppercase cursor-pointer",
            i > 0 ? "border-l-0" : "",
            active === value
              ? "text-[color:var(--ink)] [background-image:linear-gradient(var(--green-soft),var(--green-soft))]"
              : "text-[color:var(--muted)] hover:text-[color:var(--ink)]",
          ].filter(Boolean).join(" ")}
        >
          {label}
        </button>
      ))}
      {onWorkspace ? (
        <HoverTooltip placement="bottom" label="Open this trace in an investigation of its own, over the page">
          <button
            type="button"
            onClick={onWorkspace}
            className="ml-[6px] inline-flex h-[24px] items-center gap-[5px] border border-[color:var(--line)] bg-[color:var(--control-bg)] px-[8px] text-[11px] leading-[1] tracking-[0.06em] uppercase text-[color:var(--muted)] cursor-pointer hover:text-[color:var(--ink)]"
            data-open-canvas=""
          >
            Investigation
            <svg viewBox="0 0 12 12" width="9" height="9" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M4.5 3h4.5v4.5M9 3 3.5 8.5" /></svg>
          </button>
        </HoverTooltip>
      ) : null}
    </div>
  );
}
